// @flow
//  메인 토커?
export const DOMINANT_SPEAKER_CHANGED = 'DOMINANT_SPEAKER_CHANGED';
// 참가자 음소거 
export const MUTE_REMOTE_PARTICIPANT = 'MUTE_REMOTE_PARTICIPANT';
// 참가자 session brige id 추가
export const PARTICIPANT_JITSI_ID = "PARTICIPANT_JITSI_ID";
// 참가자 입장
export const PARTICIPANT_JOINED = 'PARTICIPANT_JOINED';
// 참가자 같외
export const PARTICIPANT_KICKED = 'PARTICIPANT_KICKED';
// 참가자 퇴장
export const PARTICIPANT_LEFT = 'PARTICIPANT_LEFT';
// 참가자 상태 업데이트
export const PARTICIPANT_UPDATED = 'PARTICIPANT_UPDATED';
// 판 사용자 추가 
export const PIN_PARTICIPANT = 'PIN_PARTICIPANT';
// 핀 사용자 삭제
export const DELETE_PIN_PARTICIPANT = 'DELETE_PIN_PARTICIPANT';
// 발언권 요청
export const LOCAL_PARTICIPANT_RAISE_HAND = 'LOCAL_PARTICIPANT_RAISE_HAND';
// 녹화 사용자 추가 및 삭제 
export const SET_RECORDING_PARTICIPANT = 'SET_RECORDING_PARTICIPANT';
// 페이크 사용자 
export const SET_VACATED_PARTICIPANT = 'SET_VACATED_PARTICIPANT';

// 그룹 사용자 
export const SET_GROUP_PARTICIPANT = 'SET_GROUP_PARTICIPANT';
// 
export const SET_BELONG_PARTICIPANT = 'SET_BELONG_PARTICIPANT';

export const SET_BRIDGE_PARTICIPANT = 'SET_BRIDGE_PARTICIPANT';

export const ALREADY_PARTICIPANT_JOINED = 'ALREADY_PARTICIPANT_JOINED';
export const PARTICIPANT_HANDLER_JOIN = 'PARTICIPANT_HANDLER_JOIN';